import { GET_MODALITY_OPTIONS } from "../actions/patientAction"


const devicesOptionReducer = (state = [], { type,  payload = [] }) => {
  switch (type) {
    case GET_MODALITY_OPTIONS:
      return getOptionFilter(payload)
    default:
      return state
  }
}
  
export default devicesOptionReducer

const getOptionFilter = (data)=>{
  let modoption = {}
  let devOptions = {}
  let options = {}

  if(data){
    data.map(item => {
    let modalityOption = {}
    let deviceOptions = {}
      modalityOption = {
        [item.type_modality] :{
          label: item.type_modality,
          value: item.guid
        }
      }
      deviceOptions = {
      [item.nickname] :{
        label: item.nickname,
        value: item.guid
      }
    }
    modoption = {
      ...modoption,
      ...modalityOption
    }
    devOptions = {
      ...devOptions,
      ...deviceOptions
    }
    options = {
      devOptions,
      modoption
    }
    return options
  })
}
  return options
}